var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 5.00004H7.66683V3.66671H6.3335V5.00004ZM7.00016 12.3334C4.06016 12.3334 1.66683 9.94004 1.66683 7.00004C1.66683 4.06004 4.06016 1.66671 7.00016 1.66671C9.94016 1.66671 12.3335 4.06004 12.3335 7.00004C12.3335 9.94004 9.94016 12.3334 7.00016 12.3334ZM7.00016 0.333374C6.12468 0.333374 5.25778 0.505812 4.44894 0.840844C3.6401 1.17588 2.90517 1.66694 2.28612 2.286C1.03588 3.53624 0.333496 5.23193 0.333496 7.00004C0.333496 8.76815 1.03588 10.4638 2.28612 11.7141C2.90517 12.3331 3.6401 12.8242 4.44894 13.1592C5.25778 13.4943 6.12468 13.6667 7.00016 13.6667C8.76827 13.6667 10.464 12.9643 11.7142 11.7141C12.9645 10.4638 13.6668 8.76815 13.6668 7.00004C13.6668 6.12456 13.4944 5.25766 13.1594 4.44882C12.8243 3.63998 12.3333 2.90505 11.7142 2.286C11.0952 1.66694 10.3602 1.17588 9.55139 0.840844C8.74255 0.505812 7.87564 0.333374 7.00016 0.333374ZM6.3335 10.3334H7.66683V6.33337H6.3335V10.3334Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b4431faf2e43c09e3908b96572811014.svg";
export { ForwardRef as ReactComponent };